import React from 'react'

function Footer() {
  return (
      <footer className="site-footer">
        <p>© 2025 Dotandkey, all rights reserved.</p>
      </footer>
  )
}

export default Footer